export default __webpack_public_path__ + "static/media/meebit-2.e85f5bcc.png";